import { createSafeContext } from '@mantine/utils';

const [ModalBaseProvider, useModalBaseContext] = createSafeContext("ModalBase component was not found in tree");

export { ModalBaseProvider, useModalBaseContext };
//# sourceMappingURL=ModalBase.context.js.map
